import { handleActions } from 'redux-actions';

import localize from '../../../localization/container';
import * as apiActions from '../actions';

const defaultState = {
  error: '',
  pieChart:[],
  trendchart:[],
  selectedProject:[{projectName:"", suitType:[]}],
  defaultProject:{projects:[],suitypes:[] },
  testCases:[],
  piechartBulk:[],
  trendchartBulk:[],
  tableChartBulk:[],
  user:[]

};

export const chart = handleActions(
  {
    [apiActions.pieChartSuccess]: (state, action) => {
        return {
          ...state,
          pieChart: action.payload
        };
      },
      [apiActions.trendChartSuccess]: (state, action) => {
        return {
          ...state,
          trendchart: action.payload
        };
      },

    [apiActions.pieChartFail]: (state, action) => ({
      ...state,
      error: localize({
        id: 'error.wrongEmailPassword',
        defaultMessage: 'Invalid email address or password'
      })
    }),
    [apiActions.projectSuccess]: (state, action) => ({
      ...state,
      defaultProject  :{...state.defaultProject, projects:action.payload}
    }),
    [apiActions.suitTypeSuccess]: (state, action) => ({
      ...state,
      defaultProject  :{...state.defaultProject, suitypes:action.payload}
    }),
    [apiActions.piechartBulkSuccess]: (state, action) => {
     return  {
      ...state,
      piechartBulk: action.payload
    }
    },
     [apiActions.trendchartBulkSuccess]: (state, action) => {
      return { 
       ...state,
      trendchartBulk: action.payload
     }
    }, 
    [apiActions.fetchAnalyticsSuccess]: (state, action) => {
        let key = Object.keys(action.payload)[0];
      return { 
       ...state,
       tableChartBulk: [...state.tableChartBulk.filter(fa => Object.keys(fa)[0] !== key), action.payload]
     }
    },
    [apiActions.userinfomationSuccess]: (state, action) => {
      return { 
        ...state,
       user: action.payload
      }
     },
    [apiActions.testCasesSuccess]: (state, action) => {
      return {
        ...state,
        testCases: [...state.testCases, action.payload]
      };
    },

    
  },
  defaultState
);
